// extracted by mini-css-extract-plugin
module.exports = {"question-prefix":"DescriptionListItem_question-prefix__tYuJd","text":"DescriptionListItem_text__Z47lc","description-term-text":"DescriptionListItem_description-term-text__EUzGi"};